import React, { useState, useEffect } from 'react';
import welcome from '../../Images/mfi_IDCard_logo.png';
import Confetti from 'react-confetti';
import Axiosfetch from '../Common/Axiosfetch';
import baseURL from '../Common/Config';
import FailureAlert from '../Common/Failure';
import { ValidateEventRegistration, CallBackAlert } from '../Common/Validations/validation';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faPhoneVolume, faTimes } from '@fortawesome/free-solid-svg-icons';
import moment from 'moment';

const EventRecord = {
    EventID: "",
    PartnerID: "",
    ShirtsQuantity: 0,
    ShirtsSize: "",
    Remarks: "",
    Approved: 0,
    Present: 0,
    IsDeleted: 0
};

const Event = () => {
    const [EventRecordsData, setEventRecordsData] = useState({});
    const [DisplayRegister, setDisplayRegister] = useState("none");
    const [DisplayRegisterID, setDisplayRegisterID] = useState("none");
    const [eventRecordData, setEventRecordData] = useState(EventRecord);
    const [RegistrationID, setRegistrationID] = useState("");

    useEffect(() => {
        FetchEventRecords();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const FetchEventRecords = () => {
        Axiosfetch(baseURL + "GetActiveEventDetails", "POST", {
            APIKey: process.env.REACT_APP_INTERNAL_KEY.toString()
        }, EventRecordsuccess, Failure);
    };

    const EventRecordsuccess = (data) => {
        if (data && data.length > 0) {
            setEventRecordsData(data[data.length - 1]);
            setEventRecordData({ ...eventRecordData, "EventID": data[data.length - 1]._id });
        }
        else {
            setEventRecordsData([]);
        }
    };

    const hideRegister = () => {
        setDisplayRegisterID("none");
        setRegistrationID("");
    }

    const onTextChange = (e) => {
        let value = e.target.value;
        setEventRecordData({ ...eventRecordData, [e.target.name]: value });
    };

    const onNumberChange = (e) => {
        let value = e.target.value ? parseInt(e.target.value) : 0;
        setEventRecordData({ ...eventRecordData, [e.target.name]: value });
    };

    const SaveRegistration = () => {
        if (ValidateEventRegistration(eventRecordData)) {
            var details = eventRecordData;
            details.APIKey = process.env.REACT_APP_INTERNAL_KEY.toString();
            Axiosfetch(baseURL + "CreateEventRegistration", "POST",
                details, EventRecordDetailsSuccess, Failure);
        }
    }

    const EventRecordDetailsSuccess = (data) => {
        if (data.success) {
            if (data?.data) {
                setDisplayRegisterID("block");
                setEventRecordData(EventRecord);
                setRegistrationID(data.data._id)
            }

            setDisplayRegister("none");
        }
        else {
            CallBackAlert(data);
        }
    }

    const Failure = (err) => {
        FailureAlert(err);
    };

    return (
        <div className="container-fluid" style={{ backgroundColor: "#dfeaeb" }}>
            <div className="row" style={{ position: "relative", overflow: "hidden" }}>
                <div className="col-md-8 align-center">
                    {EventRecordsData && EventRecordsData._id !== undefined && EventRecordsData.Image ? (
                        <img className="event-Image-style" alt="Event"
                            src={`${baseURL}EventImage/${EventRecordsData.Image}`}></img>) :
                        (<img className='mt-4' alt="Event" width="100" height="100"
                            src={welcome}></img>)}
                </div>
                <div className="col-md-4 align-left">
                    {EventRecordsData && EventRecordsData._id !== undefined && (<div style={{ height: "85vh", marginTop: "1rem" }}>
                        <h2 style={{ marginBottom: "1rem" }}>{EventRecordsData.Heading}</h2>
                        <h5>{EventRecordsData.Description}</h5>
                    </div>)}
                    {EventRecordsData && EventRecordsData._id === undefined && (
                        <div style={{ height: "85vh", marginTop: "1rem" }}>
                            <h4 className='mt-4 align-center'>No Events Happening Currently !!</h4>
                        </div>
                    )}
                    <div className="align-center">
                        <div style={{ display: "flex", justifyContent: "space-around" }}>
                            <a title="Post your enquiry here..." className="bcard-btn hover-style" rel="noopener noreferrer" href="https://mail.google.com/mail/?view=cm&fs=1&to=ms@moversfederation.org" target="_blank">
                                <h4 className="responsive-icon"><FontAwesomeIcon icon={faEnvelope}></FontAwesomeIcon></h4>
                                <span className="responsive-text">Email</span></a>
                            {(EventRecordsData && EventRecordsData._id !== undefined &&
                                moment() < moment(EventRecordsData.EndDate) && moment() >= moment(EventRecordsData.StartDate)) && (<div className="bcard-btn hover-style"
                                    onClick={() => setDisplayRegister("block")}>Register</div>)}
                            <a title="Call for more details..." className="bcard-btn hover-style" href="tel:+917090678678">
                                <h4 className="responsive-icon"><FontAwesomeIcon icon={faPhoneVolume}></FontAwesomeIcon></h4>
                                <span className="responsive-text">Phone</span></a>
                        </div>
                    </div>
                </div>
                <Confetti></Confetti>
                <div className="modal" style={{ display: DisplayRegister }}>
                    <div className="modal-content">
                        <div className='mb-2'>
                            <h5 style={{ marginLeft: "5px" }}>Event Registration</h5>
                        </div>

                        <table className="table">
                            <tbody>
                                <tr>
                                    <td>
                                        <h6>Member ID<span className="mandatoryStar">*</span></h6>
                                    </td>
                                    <td>
                                        <input type="text" name="PartnerID"
                                            className="form-control"
                                            onChange={e => onTextChange(e)}
                                            value={eventRecordData.PartnerID}></input>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <h6>Total Shirts<span className="mandatoryStar">*</span></h6>
                                    </td>
                                    <td>
                                        <input type="text" name="ShirtsQuantity"
                                            className="form-control"
                                            onChange={e => onNumberChange(e)}
                                            value={!isNaN(eventRecordData.ShirtsQuantity) && eventRecordData.ShirtsQuantity > 0 ?
                                                eventRecordData.ShirtsQuantity : ""}></input>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <h6>Shirts Size<span className="mandatoryStar">*</span></h6>
                                    </td>
                                    <td>
                                        <input type="text" name="ShirtsSize"
                                            className="form-control"
                                            onChange={e => onTextChange(e)}
                                            value={eventRecordData.ShirtsSize}></input>
                                        <div style={{ color: "red" }}>In case, total shirts required is more than 1, mention the size as comma seperated.</div>
                                        <div style={{ color: "red" }}>Example : XXL , XL , L , M , S</div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <h6>Remarks</h6>
                                    </td>
                                    <td>
                                        <textarea name="Remarks"
                                            className="form-control"
                                            onChange={e => onTextChange(e)}
                                            value={eventRecordData.Remarks}></textarea>
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan="2" style={{ textAlign: "right" }}>
                                        <div className="row">
                                            <div className="col-md-12">
                                                <button type="button" style={{ fontSize: "1.4rem" }} className={`btn btn-Save`}
                                                    onClick={SaveRegistration}>Save</button>
                                                <button type="button" className="btn btn-default" onClick={() => setDisplayRegister("none")}>Close</button>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="modal" style={{ display: DisplayRegisterID }}>
                    <div className="modal-content" style={{ textAlign: "center" }}>
                        <div>
                            <div onClick={hideRegister} style={{ textAlign: "right", fontSize: "18px" }}>
                                <FontAwesomeIcon className='cursorpointer' icon={faTimes}></FontAwesomeIcon></div>
                        </div>
                        <div className='mb-2'>
                            <h2 style={{ marginLeft: "5px", color: "green" }}>Event Registration Succesful !!</h2>
                        </div>
                        <div>
                            <h6>Registration ID</h6>
                            <h4 style={{ textTransform: "uppercase" }}>{RegistrationID}</h4>
                        </div>
                        <div style={{ color: "red" }}>
                            Please note the Registration ID. This might be required at the of the event.
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Event;